module.exports = __webpack_public_path__ + "img/pay_fail.c3dcbd04.png";